<template>
  <div>
    <transition name="modal-slide">
      <div class="modal"
        v-show="is_open"
        v-on:click="onOverlayClick">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" v-on:click="close">
                <span aria-hidden="true">×</span>
              </button>
              <slot name="title"></slot>
            </div>
            <div class="modal-body">
              <slot name="body"></slot>
            </div>
            <div class="modal-footer" v-if="$slots.footer">
              <slot name="footer"></slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="overlay-fade">
      <div class="modal-overlay" v-show="is_open"></div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    blocking: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    is_open: function(value) {
      document.body.classList.toggle('modal-open', value);
    },
  },
  data: function() {
    return {
      is_open: false,
    };
  },
  methods: {
    open() {
      this.is_open = true;

      this.$emit('open');
    },
    close() {
      this.is_open = false;

      this.$emit('close');
    },
    onOverlayClick(event) {
      if (!event.target.classList || event.target.classList.contains('modal')) {
        if (!this.blocking) {
          this.close();
        }
      }
    },
  },
};
</script>

<style lang="scss" scope>
.modal,
.modal-overlay {
  display: block;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  z-index: 1600;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-slide-enter {
  transform: translate(0, -100%);
}

.modal-slide-enter-active {
  transition: transform .6s ease;
}

.modal-slide-leave-to {
  transform: translate(0, 0);
}

.modal-slide-leave-active {
  transition: transform .6s ease;
  transform: translate(0, -100%);
}

.overlay-fade-enter {
  opacity: 0;
}

.overlay-fade-enter-active {
  transition: all .6s ease;
}

.overlay-fade-leave-to {
  opacity: 1;
}

.overlay-fade-leave-active {
  transition: all .6s ease;
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// Modal.vue?07509e12